export * from './map-component';
